import { action, makeObservable, observable } from 'mobx';
import { computedFn } from 'mobx-utils';
import Message from '../models/message';
import processIncomingData from '../processIncomingData';
import { getLastMessageForChannel } from '../../helpers/channelHelpers';
import {
  checkPreviousMessageType,
  getFilteredMessagesForChannel,
  getFormattedTimestamp,
  getUnseenMessages,
} from '../../helpers/messageHelpers';
import * as utils from '../../helpers/utils';

class MessageStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable messages = [];

  @action actionDeleteEntry(incObj) {
    const existingObject = this.messages.find((f) => f._id === incObj._id);

    if (existingObject) {
      return this.messages.remove(existingObject);
    }

    return false;
  }

  computedGetLastMessageForChannel = computedFn(function computedGetLastMessageForChannel(channel) {
    return getLastMessageForChannel(
      this.messages,
      channel,
      this.rootStore.settingsStore.getLoggedUserSettings.HiddenMessages
    );
  });

  computedGetUnseenMessages = computedFn(function computedGetUnseenMessages(
    channel,
    typesToFilter,
    channelStateToFilter
  ) {
    return getUnseenMessages(
      this.rootStore.channelStore.channels
        .map((m) =>
          getLastMessageForChannel(
            this.messages,
            m,
            this.rootStore.settingsStore?.getLoggedUserSettings?.HiddenMessages
          )
        )
        .filter(Boolean),
      this.rootStore.commonStore.getLoggedUser,
      channel,
      typesToFilter,
      channelStateToFilter
    );
  });

  computedGetFormattedTimestamp = computedFn((message) => getFormattedTimestamp(message));

  computedCheckPreviousMessageType = computedFn((previousMessage, newMessage) =>
    checkPreviousMessageType(previousMessage, newMessage)
  );

  computedGetFilteredMessagesForChannel = computedFn(function computedGetFilteredMessagesForChannel(
    channel
  ) {
    return getFilteredMessagesForChannel(
      this.messages,
      channel,
      this.rootStore.settingsStore.getLoggedUserSettings.ShowHiddenMessages,
      this.rootStore.settingsStore.getLoggedUserSettings.HiddenMessages
    );
  });

  GetWelcomeChannelMessage = computedFn(function getWelcomeChannelMessage(channel) {
    return channel
      ? this.messages.find(
          (m) =>
            m.Channel._id === channel._id &&
            m.MessageType.TypeId === utils.MessageTypeEnum.WelcomeChannelMessage.TypeId
        )
      : null;
  });

  GetClosedChannelMessage = computedFn(function getClosedChannelMessage(channel) {
    return channel
      ? this.messages.find(
          (m) =>
            m.Channel._id === channel._id &&
            m.MessageType.TypeId === utils.MessageTypeEnum.ClosedChannelMessage.TypeId
        )
      : null;
  });

  @action setClearAllNotifications() {
    this.rootStore.settingsStore.getLoggedUserSettings.ClearNotificationsFrom = new Date().toISOString();
  }

  @action setMessages(messages) {
    this.messages = messages;
  }

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.messages, Message);
  }
}

export default MessageStore;
